export default __webpack_public_path__ + "static/media/CAM.f377e3b8.svg";